import React, { Component } from 'react';
import { connect } from "react-redux";
import * as actions from "../actions";
import { Field, reduxForm, formValueSelector } from 'redux-form';
import * as _ from 'lodash';
import {
    EmailShareButton,
    FacebookShareButton,
    TwitterShareButton,
    WhatsappShareButton,
} from "react-share";
//image
import loading_blue from '../assets/gif/loading_blue.gif';
import vuepay_large_logo from '../assets/images/vuepaylogonav@5x.png';
//libraries

import 'react-intl-tel-input/dist/libphonenumber.js';
import 'react-intl-tel-input/dist/main.css';
import { hidePromocodeVerification } from "../util/broadcaster/register_util";
import { getData, LOGIN } from "../util/storage";
import { isEmpty, vuepayAlert, vuePayLog } from "../util/utility";
import { renderField } from "../util/account_management";

class ApplyPromocode extends Component {

    constructor(props) {
        super(props);
        this.state = {
            promocode: this.props.initialValues.promocode,
            shareList: []
        };
        this.onSubmit = this.onSubmit.bind(this);
    }

    required = value => (value ? undefined : 'Required');

    /**
     * This is invoked when an update is caused by changes to props or state.
     * These methods are called when a component is being re-rendered
     * @param nextProps
     */
    UNSAFE_componentWillReceiveProps(nextProps) {
        
        this.setState({
            shareList: [
                <FacebookShareButton
                    url={`https://www.vuepay.com/register?promocode=${this.props.initialValues.promocode}`}
                    quote={"Share me"}
                    style={{ width: 40, height: 40 }}
                >
                    <div className="facebookicon"></div>
                </FacebookShareButton>,
                <WhatsappShareButton
                    url={`https://www.vuepay.com/register?promocode=${this.props.initialValues.promocode}`}
                    quote={"Share me"}
                    style={{ width: 40, height: 40 }}
                >
                    <div className="whatsappicon"></div>
                </WhatsappShareButton>,
                <TwitterShareButton
                    url={`https://www.vuepay.com/register?promocode=${this.props.initialValues.promocode}`}
                    quote={"Share me"}
                    style={{ width: 40, height: 40 }}
                >
                    <div className="twittericon"></div>
                </TwitterShareButton>,
                <EmailShareButton
                    url={`https://www.vuepay.com/register?promocode=${this.props.initialValues.promocode}`}
                    quote={"Share me"}
                    style={{ width: 40, height: 40 }}
                >
                    <div className="emailicon"></div>
                </EmailShareButton>
            ]
        });
        if (nextProps.broadcasterProfile && nextProps.broadcasterProfile.promocode) {
            //if the status_code received from the server is 200 means the user has successfully changed password
            if (nextProps.broadcasterProfile.promocode.status_code === 200) {
                // display success message under the promocode text filed
                document.getElementById("promo-message").innerHTML = `<span class="text-success">${nextProps.broadcasterProfile.promocode.message}</span>`
                //it the api_token and token is available we do hit getUserDetails Webservice
                getData(LOGIN)
                    .then((data) => {
                        if (!isEmpty(data)) {
                            this.props.getUserDetails(data.token, data.api_token);
                        }
                    });
            } else {
                //if the status_code received from the server is NOT 200 means there has been some error occurred
                // display error message under the promocode text filed
                document.getElementById("promo-message").innerHTML = `<span class="text-danger">${nextProps.broadcasterProfile.promocode.message}</span>`
            }
            this.props.resetUpdatePromoCode();
        }
    }

    onSubmit(values) {

        //dispatch an action to PUT the channel picture/image to the Webservice
        getData(LOGIN)
            .then((data) => {
                if (!isEmpty(data)) {
                    this.props.updatePromocode(data.token, data.api_token, values.promocode, this.props.initialValues.promocodeId)
                }
            });
    }

    render() {
        const { handleSubmit, error } = this.props;
        return (
            <div id="promotion-verification-modal" className="modal fade" role="dialog" aria-labelledby="myModalLabel"
                aria-hidden="true">
                <main role="main" className="">
                    <div className="login-container">
                        <div className="popup-header">
                            <button type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() => {
                                    this.props.dispatch(this.props.change("promocode", this.props.initialValues.promocode))
                                    this.setState({
                                        promocodeChange: false
                                    });
                                    hidePromocodeVerification();
                                    this.props.resetUpdatePromoCode();
                                    document.getElementById("promo-message").innerHTML = '';
                                    document.getElementsByClassName("modal-overlay")[0].style.display = "none";
                                }}
                            >
                                <img alt={"close-icon"}
                                    src={"https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/close.svg"} />
                            </button>
                        </div>
                        <div>
                            <div className="">
                                <div className="row">
                                    <div className="col-md-6 bg-primary d-flex align-items-center text-center"
                                        style={{ borderRight: '1px solid #e7e7e7' }}>
                                        <img src={vuepay_large_logo} className="img-fluid" alt={"VuePay logo"} />
                                    </div>
                                    <div className="col-md-6 bg-white d-flex align-items-center">
                                        <div>
                                            <div className="modal-body">
                                                <h4 className="mb-4">Send your friends discounts</h4>
                                                <p>Share the VuePay love and give friends and family free credits to try VuePay, word up to £
                                                {this.props.account_management && this.props.account_management.userDetails && this.props.account_management.userDetails.broadcaster.length > 0 && this.props.account_management.userDetails.broadcaster[0].voucher.length > 0 && this.props.account_management.userDetails.broadcaster[0].voucher[0].data.add_to_wallet_balance / 100} each!</p>
                                                <p>Share your invite code</p>

                                                <form className="promocode" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                                                    <Field
                                                        label=""
                                                        name="promocode"
                                                        type="text"
                                                        height={"47px"}
                                                        share={this.props.checkPromp}
                                                        shareList={this.state.shareList}
                                                        username={null}
                                                        validate={[this.required]}
                                                        component={renderField}
                                                        normalize={(value, previousValue, allValues, previousAllValues)=>{
                                                            console.log(value);
                                                            return value ? value.toLowerCase() : '';
                                                        }}
                                                    />
                                                    <div id="promo-message"></div>
                                                    {!this.props.checkPromp && <div className="mt-4 text-center">
                                                        <button className="btn btn-primary">
                                                            {
                                                                this.props.broadcaster.verify_otp.isFetching
                                                                    ?
                                                                    <img src={loading_blue} alt={"Loading"} width={26} height={26} />
                                                                    :
                                                                    'Submit'
                                                            }
                                                        </button>
                                                        <button type="button" className="btn btn-outline-primary"
                                                            onClick={() => {
                                                                this.props.dispatch(this.props.change("promocode", this.props.initialValues.promocode));
                                                                document.getElementById("promo-message").innerHTML = '';
                                                            }}>
                                                            Cancel
                                                </button></div>}
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const selector = formValueSelector('PromocodeForm');
    const promocodeValue = selector(state, "promocode");
    const initialValues = {
        promocode: state.account_management && state.account_management.userDetails && state.account_management.userDetails.broadcaster.length > 0 && state.account_management.userDetails.broadcaster[0].voucher.length > 0 && state.account_management.userDetails.broadcaster[0].voucher[0].code,
        promocodeId: state.account_management && state.account_management.userDetails && state.account_management.userDetails.broadcaster.length > 0 && state.account_management.userDetails.broadcaster[0].voucher.length > 0 && state.account_management.userDetails.broadcaster[0].voucher[0].id
    }
    const checkPromp = promocodeValue === initialValues.promocode
    return {
        account_management: state.account_management,
        device: state.device.payload,
        broadcasterProfile: state.broadcasterProfile,
        broadcaster: {
            verify_otp: state.broadcaster_verify_otp,
            resend_otp: state.broadcaster_resend_otp,
            change_mobile_number: state.broadcaster_change_mobile_number
        },
        checkPromp,
        initialValues
    };
}

// Decorate with reduxForm(). It will read the initialValues prop provided by connect()
ApplyPromocode = reduxForm({
    form: 'PromocodeForm', // a unique identifier for this form
    enableReinitialize: true,
})(ApplyPromocode)

// You have to connect() to any reducers that you wish to connect to yourself
ApplyPromocode = connect(
    mapStateToProps, // pull initial values from account reducer
    actions // bind account loading action creator
)(ApplyPromocode)

export default ApplyPromocode;